
import React from "react";
import { Link, useSearchParams } from "react-router-dom";

const ContentFilterTabs2 = () => {

  const [searchParams] = useSearchParams();
  const filter = searchParams.get("filter") || "all";
  const activeFilter = searchParams.get("filter") || "all";

  const filters = [
    { id: "all", label: "الكل", path: "/markets?filter=all", urlValue: "all" },
    { id: "popular", label: "الأكثر شعبية", icon: "/assets/images/fire.svg", activeIcon: "/assets/images/fireac.svg", iconSize: "w-6 h-6", activeIconSize: "w-4 h-4", path: "/markets?filter=popular", urlValue: "popular" },
    { id: "rated", label: "الأعلى تقييماً", icon: "/assets/images/mo.svg", activeIcon: "/assets/images/margin-wrap-2.svg", iconSize: "w-4 h-4", activeIconSize: "w-6 h-6", path: "/markets?filter=top_rated", urlValue: "top_rated" },
    { id: "discounts", label: "خصومات", icon: "/assets/images/kh.svg", activeIcon: "/assets/images/margin-wrap-1.svg", iconSize: "w-4 h-4", activeIconSize: "w-6 h-6", path: "/markets?filter=with_offers", urlValue: "with_offers" },
    // { id: "grocery", label: "توصيل مجانى", icon: "/assets/images/tr.svg", activeIcon: "/assets/images/margin-wrap.svg", iconSize: "w-4 h-4", activeIconSize: "w-6 h-6", path: "/markets?filter=with_delivery", urlValue: "with_delivery" }
  ];

  return (
    <div className="bg-[#F8F8F8] sticky top-0 z-30  font-[cairo] mb-1">
      <div className="overflow-x-auto touch-pan-x scrollbar-hide">
        <div className="flex gap-2 px-4 py-1 w-max min-w-full overflow-x-auto md:justify-center md:w-full md:overflow-visible">

          {filters.map((tab) => {
            const isActive = filter === tab.urlValue;
            return (
              <Link
                key={tab.id}
                to={tab.path}
                className={`
        content-filter-tab2
        flex items-center gap-2 flex-shrink-0
        px-3 whitespace-nowrap
        rounded-xl text-[12px] lg:text-[16px] transition
        ${isActive ? "active" : ""}
      `}
              >
                {tab.icon && tab.id !== "all" && (
                  <img
                    src={isActive ? tab.activeIcon : tab.icon}
                    alt={tab.label}
                    className={isActive ? tab.activeIconSize : tab.iconSize}
                  />
                )}
                <span>{tab.label}</span>
              </Link>
            );
          })}

        </div>
      </div>
    </div>
  );
};

export default ContentFilterTabs2;